import Back from './Back';
import ChildrenWrapper from './ChildrenWrapper';
import ContainerDiv from './ContainerDiv';
import Div from './Div';
import Flipper from './Flipper';
import Front from './Front';
import Wrapper from './Wrapper';

const LoaderCore = {
  Back,
  ChildrenWrapper,
  ContainerDiv,
  Div,
  Flipper,
  Front,
  Wrapper,
};

export default LoaderCore;
